<script>
import SettingField from './SettingField'
export default {
    name: 'DocumentTemplateField',
    extends: SettingField,
    props: {
        field: {
            type: Object,
            required: true,
        },
        settingValues: {
            type: Object,
            required: false,
        },
        completions: {
            type: Array,
            default: () => []
        },
        macros: {
            type: Array,
            default: () => []
        },
    },
    computed: {
        value: {
            get() {
                if (this.disabled) return this.field.default
                else return this.field.template
            },
            set(value) {
                if (!this.disabled) this.$emit('input', value)
            }
        },
        values: {
            get() {
                // TODO
            },
            set(options) {
                // TODO
            }
        },
    }
}
</script>
